// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"deleteButton_buttonWrapper__LKUhC","marginRight":"deleteButton_marginRight__-CjBE"};